<template>
  <div :class="$style.wrapper">
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :class="$style.table"
      @on-column-filter="updateFilters"
      @on-sort-change="onSortChange"
      :sort-options="{
        enabled: true,
        initialSortBy: { field: 'createdAt', type: 'desc' }
      }"
      :pagination-options="{
        enabled: true,
        infoFn: () => {}
      }"
      compactMode
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'operationId'">
          <p class="adminPrimaryId">{{ props.row.operationId }}</p>
        </span>
        <span v-else-if="props.column.field === 'reference'">
          <a
            :href="
              props.row.reference.startsWith('#')
                ? props.row.reference
                : `#${props.row.reference}`
            "
            target="_blank"
            >Visit Page</a
          >
        </span>
        <span v-else-if="props.column.field === 'requestedBy'">
          <router-link
            :to="{
              name: 'user-profile',
              params: { userId: props.row.userId }
            }"
          >
            {{ props.row.requestedBy }}
            <p class="adminSecondaryId">{{ props.row.userId }}</p>
          </router-link>
        </span>
        <span v-else-if="props.column.field === 'action'">
          <div :class="$style.operations">
            <FormButton
              @click="handleApproveOpened(props.row.operationId)"
              :ghost="true"
              :class="$style.approve"
              >Approve</FormButton
            >
            <FormButton
              @click="handleDenyOpened(props.row.operationId)"
              :ghost="true"
              :class="$style.deny"
              >Deny</FormButton
            >
          </div>
        </span>
      </template>
    </vue-good-table>

    <!-- Confirmation pop up for Approve  -->
    <ModalNew
      :showModal="showApproveModal"
      v-transfer-dom
      :class="$style.modalOperationConfirmation"
      @close="handleApproveClosed"
    >
      Are you sure you want to approve this operation?
      <div :class="$style.buttonsOperationConfirmation">
        <FormButton @click="approveOperation(approveID)" :ghost="true"
          >Yes</FormButton
        >
        <FormButton @click="handleApproveClosed" :ghost="true">No</FormButton>
      </div>
    </ModalNew>

    <!-- Confirmation pop up for Deny  -->
    <ModalNew
      :showModal="showDenyModal"
      :class="$style.modalOperationConfirmation"
      v-transfer-dom
      @close="handleDenyClosed"
    >
      <p>Are you sure you want to deny this operation?</p>
      <div :class="$style.buttonsOperationConfirmation">
        <FormButton @click="denyOperation(denyID)" :ghost="true"
          >Yes</FormButton
        >
        <FormButton @click="handleDenyClosed" :ghost="true">No</FormButton>
      </div>
    </ModalNew>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { VueGoodTable } from 'vue-good-table';
import {
  GET_PENDING_OPERATIONS,
  APPROVE_OPERATION,
  REJECT_OPERATION
} from '@/store/actions.type';
import { SET_GLOBAL_ERROR } from '@/store/mutations.type';
export default {
  components: {
    VueGoodTable
  },
  data() {
    return {
      display404: false,
      showApproveModal: false,
      showDenyModal: false,
      denyID: null,
      approveID: null,
      columns: [
        {
          label: 'ID',
          type: 'number',
          field: 'operationId',
          filterOptions: {
            enabled: true,
            filterValue: this.loadUrlWithFilters('operationId')
          }
        },
        {
          label: 'Type',
          field: 'function',
          filterOptions: {
            enabled: true,
            filterValue: this.loadUrlWithFilters('function')
          }
        },
        {
          label: 'Requested by',
          field: 'requestedBy',
          filterOptions: {
            enabled: true,
            filterValue: this.loadUrlWithFilters('requestedBy')
          }
        },
        {
          label: 'Created at',
          type: 'date',
          dateInputFormat: 'dd.MM.yyyy',
          dateOutputFormat: 'dd.MM.yyyy',
          field: 'createdAt',
          filterOptions: {
            enabled: true,
            filterValue: this.loadUrlWithFilters('createdAt')
          }
        },
        {
          label: 'Reference',
          field: 'reference'
        },
        {
          label: 'Action',
          field: 'action'
        }
      ],
      rows: []
    };
  },
  computed: {
    ...mapGetters(['isCurrentUserTeachingStaff'])
  },
  async created() {
    if (!this.isCurrentUserTeachingStaff) {
      this.display404 = true;
    } else {
      this.fetchOperations();
    }
  },
  methods: {
    handleApproveOpened(approveID) {
      this.approveID = approveID;
      this.showApproveModal = true;
    },
    handleDenyOpened(denyID) {
      this.denyID = denyID;
      this.showDenyModal = true;
    },
    handleApproveClosed() {
      this.approveID = null;
      this.showApproveModal = false;
    },
    handleDenyClosed() {
      this.denyID = null;
      this.showDenyModal = false;
    },
    fetchOperations() {
      this.$store
        .dispatch(GET_PENDING_OPERATIONS)
        .then(operations => {
          this.operations = operations;
        })
        .then(operations => {
          this.createRows();
        })
        .then(() => {
          this.$emit('pendingCount', this.rows.length);
        })
        .catch(error => {
          this.$store.commit(SET_GLOBAL_ERROR, { error, log: true });
        });
    },
    createRows() {
      this.rows = [];

      if (!this.operations) return [];
      this.operations.filter(operation => {
        const req = operation.requested_by;
        this.rows.push({
          operationId: operation.operation_id || '',
          function: operation.func || '',
          requestedBy:
            (req && req.name.first_name) + ' ' + (req && req.name.last_name) ||
            '',
          userId: (req && req.user_id) || '',
          createdAt: moment(operation.created_at).format('DD.MM.yyyy') || '',
          reference: operation.object.reference || ''
        });
      });
    },
    approveOperation(operationId) {
      this.$store
        .dispatch(APPROVE_OPERATION, operationId)
        .then(() => {
          this.showApproveModal = false;
          this.fetchOperations();
        })
        .catch(error => {
          this.$store.commit(SET_GLOBAL_ERROR, { error, log: true });
        });
    },
    denyOperation(operationId) {
      this.$store
        .dispatch(REJECT_OPERATION, operationId)
        .then(() => {
          this.showDenyModal = false;
          this.fetchOperations();
        })
        .catch(error => {
          this.$store.commit(SET_GLOBAL_ERROR, { error, log: true });
        });
    },
    onSortChange(sort) {
      var sorting = {
        sort: sort[0].field || [],
        order: sort[0].type || []
      };

      return sort[0].type === 'none'
        ? this.updateQueryFilters(this.searchParams)
        : this.updateQueryFilters({ ...this.searchParams, ...sorting });
    },
    loadUrlWithSorting() {
      if (this.$route && this.$route.query && this.$route.query.order) {
        return {
          field: this.$route.query.sort,
          type: this.$route.query.order
        };
      }

      return {};
    },
    loadUrlWithFilters(param) {
      switch (param) {
        case 'operationId':
          return this.$route.query.operationId;
          break;
        case 'function':
          return this.$route.query.function;
          break;
        case 'requestedBy':
          return this.$route.query.requestedBy;
          break;
        case 'date':
          return this.$route.query.date;
          break;
        default:
          return '';
      }
    },
    updateFilters(filterString) {
      var column = filterString.columnFilters;

      this.searchParams = {
        operationId: column.operationId || [],
        function: column.function || [],
        requestedBy: column.requestedBy || [],
        date: column.date || []
      };

      this.updateQueryFilters(this.searchParams);
    },
    updateQueryFilters(newQuery) {
      this.$router.replace({ query: newQuery }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" module>
@import '../AdminTables.scss';
@import './AdminOperations.scss';
</style>
